module.exports = __webpack_public_path__ + "static/img/sl02.b94b5c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl02.jpg
// module id = Mp3Y
// module chunks = 0